const KEY = "vt_login_next";

export const safeNext = (v) => (v && v.startsWith("/") && !v.startsWith("//") ? v : null);

export const loginPath = (pathname) =>
  pathname.startsWith("/taller/") ? `/login?next=${encodeURIComponent(pathname)}` : "/login";

export const stashNext = (v) => { if (safeNext(v)) sessionStorage.setItem(KEY, v); else sessionStorage.removeItem(KEY); };

export const popNext = () => { const v = sessionStorage.getItem(KEY); sessionStorage.removeItem(KEY); return safeNext(v); };

export const homeFor = (u, next) =>
  u.role === "super_admin" ? "/admin" : u.role === "business" ? (next?.startsWith("/maestro") ? next : "/maestro") : (next || "/explorar");
